import axios from "axios";
import { FintracPagination } from "@services/models/Fintrac/FintracModel";

export const displayText = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return "—";
  return String(value);
};

export const readFintracError = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      | { originalMsg?: unknown; msg?: unknown }
      | undefined;
    if (typeof data?.originalMsg === "string" && data.originalMsg.trim()) {
      return data.originalMsg.trim();
    }
    if (typeof data?.msg === "string" && data.msg.trim()) {
      return data.msg.trim();
    }
  }
  return "Request failed";
};

export const normalizePagination = (
  pagination: Partial<FintracPagination> | undefined,
  page: number,
  limit: number,
): FintracPagination => ({
  page: pagination?.page ?? page,
  limit: pagination?.limit ?? limit,
  totalRecords: pagination?.totalRecords ?? 0,
  totalPages: pagination?.totalPages ?? 0,
});

export const FINTRAC_DEFAULT_COL_DEF = {
  sortable: false,
  filter: false,
  floatingFilter: false,
  resizable: true,
  suppressSizeToFit: true,
  suppressHeaderMenuButton: true,
  headerClass: "ag-header-cell-custom",
  cellClass: "ag-cell-custom items-center",
  cellDataType: "text" as const,
};
